/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SignalTypeEnum {
    MATCH = 'match',
    STANDING = 'standing',
    FEED = 'feed',
    TEAM = 'team',
    BASE = 'base',
}
